import { render, staticRenderFns } from "./VObjectListing.vue?vue&type=template&id=6c66004a&"
import script from "./VObjectListing.vue?vue&type=script&lang=js&"
export * from "./VObjectListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports